import React from "react"

import Aluhaus from "../images/offer/items/okna/aluhaus.svg"
import Oknoplast from "../images/offer/items/okna/oknoplast.svg"
import Wnd from "../images/offer/items/okna/wnd.svg"
import ExitIcon from "../images/menu-exit.svg"

import AluhausDrzwi from "../images/offer/items/drzwi/Aluhaus.svg"
import Cal from "../images/offer/items/drzwi/Cal.svg"
import Capek from "../images/offer/items/drzwi/Capek.png"
import Centurion from "../images/offer/items/drzwi/Centurion.svg"
import Delta from "../images/offer/items/drzwi/Delta.svg"
import Doorsystem from "../images/offer/items/drzwi/Doorsystem.png"
import Erkado from "../images/offer/items/drzwi/Erkado.png"
import Hormann from "../images/offer/items/drzwi/Hormann.svg"
import Intenso from "../images/offer/items/drzwi/Intenso.svg"
import Invado from "../images/offer/items/drzwi/Invado.svg"
import Kmt from "../images/offer/items/drzwi/KMT.svg"
import Martom from "../images/offer/items/drzwi/Martom.svg"
import PolSkone from "../images/offer/items/drzwi/Pol_skone.svg"
import Porta from "../images/offer/items/drzwi/Porta.svg"
import Wiked from "../images/offer/items/drzwi/Wiked.png"

import HormannBramy from "../images/offer/items/bramy/Hormann.svg"
import Krispol from "../images/offer/items/bramy/Krispol.svg"
import Novoferm from "../images/offer/items/bramy/Novoferm.svg"
import Wisniowski from "../images/offer/items/bramy/Wisniowski.svg"

import Anwis from "../images/offer/items/rolety/Anwis.svg"
import Dormax from "../images/offer/items/rolety/Dormax.svg"
import Perfecta from "../images/offer/items/rolety/Perfecta.svg"

import Sunzal from "../images/offer/items/markizy/Sunzal.svg"

import Beninca from "../images/offer/items/smart/Beninca.svg"
import Bft from "../images/offer/items/smart/BFT.svg"
import Somfy from "../images/offer/items/smart/Somfy.svg"

const handleChildClick = e => {
  e.stopPropagation()
}

const Popup = props => {
  console.log(props)
  switch (props.activeItem) {
    case "Okna":
      return (
        <div className="item-popup" onClick={props.closePopup}>
          <div className={`item-popup__inner ${props.isLeaveAnimation ? "item-popup__inner--hidePopup" : ""}`} onClick={handleChildClick}>
            {/* <div className={`item-popup__inner ${isLeaveAnimation ? "item-popup__inner--hidePopup" : ""}`} onClick={this.handleChildClick}> */}
            <img src={ExitIcon} alt="Exit" onClick={props.closePopup} />
            <div className="item-popup__content">
              <img src={Aluhaus} alt="Aluhaus" />
              <img src={Wnd} alt="Wnd" />
              <img src={Oknoplast} alt="Oknoplanst" />
            </div>
          </div>
        </div>
      )
    case "Drzwi":
      return (
        <div className="item-popup" onClick={props.closePopup}>
          <div className={`item-popup__inner ${props.isLeaveAnimation ? "item-popup__inner--hidePopup" : ""}`} onClick={handleChildClick}>
            {/* <div className={`item-popup__inner ${isLeaveAnimation ? "item-popup__inner--hidePopup" : ""}`} onClick={this.handleChildClick}> */}
            <img src={ExitIcon} alt="Exit" onClick={props.closePopup} />
            <div className="item-popup__content">
              <img src={AluhausDrzwi} alt="Aluhaus" />
              <img src={Cal} alt="Cal" />
              <img src={Capek} alt="Capek" />
              <img src={Centurion} alt="Centurion" />
              <img src={Delta} alt="Delta" />
              <img src={Doorsystem} alt="Doorsystem" />
              <img src={Erkado} alt="Erkado" />
              <img src={Hormann} alt="Hormann " />
              <img src={Intenso} alt="Intenso" />
              <img src={Invado} alt="Invado" />
              <img src={Kmt} alt="KMT" />
              <img src={Martom} alt="Martom" />
              <img src={PolSkone} alt="PolSkone" />
              <img src={Porta} alt="Porta" />
              <img src={Wiked} alt="Wiked" />
            </div>
          </div>
        </div>
      )
    case "Bramy":
      return (
        <div className="item-popup" onClick={props.closePopup}>
          <div className={`item-popup__inner ${props.isLeaveAnimation ? "item-popup__inner--hidePopup" : ""}`} onClick={handleChildClick}>
            <img src={ExitIcon} alt="Exit" onClick={props.closePopup} />
            <div className="item-popup__content">
              <img src={HormannBramy} alt="Hormann" />
              <img src={Krispol} alt="Krispol" />
              <img src={Novoferm} alt="Novoferm" />
              <img src={Wisniowski} alt="Wiśniowski" />
            </div>
          </div>
        </div>
      )
    case "Rolety":
      return (
        <div className="item-popup" onClick={props.closePopup}>
          <div className={`item-popup__inner ${props.isLeaveAnimation ? "item-popup__inner--hidePopup" : ""}`} onClick={handleChildClick}>
            <img src={ExitIcon} alt="Exit" onClick={props.closePopup} />
            <div className="item-popup__content">
              <img src={Anwis} alt="Anwis" />
              <img src={Dormax} alt="Dormax" />
              <img src={Perfecta} alt="Perfecta" />
            </div>
          </div>
        </div>
      )
    case "Markizy":
      return (
        <div className="item-popup" onClick={props.closePopup}>
          <div className={`item-popup__inner ${props.isLeaveAnimation ? "item-popup__inner--hidePopup" : ""}`} onClick={handleChildClick}>
            <img src={ExitIcon} alt="Exit" onClick={props.closePopup} />
            <div className="item-popup__content">
              <img src={Sunzal} alt="Sunzal" />
            </div>
          </div>
        </div>
      )
    case "Smart":
      return (
        <div className="item-popup" onClick={props.closePopup}>
          <div className={`item-popup__inner ${props.isLeaveAnimation ? "item-popup__inner--hidePopup" : ""}`} onClick={handleChildClick}>
            <img src={ExitIcon} alt="Exit" onClick={props.closePopup} />
            <div className="item-popup__content">
              <img src={Beninca} alt="Beninca" />
              <img src={Bft} alt="BFT" />
              <img src={Somfy} alt="Somfy" />
            </div>
          </div>
        </div>
      )
    default:
      return null
  }
}

export default Popup
